'use strict';
const angular = require('angular');
const {equals, isArray, isDate, isFunction, isNumber, isObject, isString, isUndefined} = angular;
const includes = require('lodash/includes');

import {FieldError} from './FieldError';

export const $domainValidationImport = [
  '$window',
  DomainValidationService];

function DomainValidationService(
  $window,
) {
  this.FieldError = FieldError;

  this.validateConstraint = validateConstraint;
  this.validateType = validateType;
  this.validateValue = validateValue;

  function validateConstraint(value, constraint, errors, className, fieldName, instance) {
    errors = errors || [];

    var validatorResult;
    if (typeof constraint === 'undefined' || constraint === null) {
      return errors;
    } else if (isObject(constraint)) {
      // TODO: consider if we want to support multi-type properties. would need to check an array of validators or something
      if (typeof constraint.type === 'string') {

        if (instance && constraint.type === 'Domain') {
          value = instance.$getLink(fieldName);
        }

        errors = validateType(value, constraint, errors, className, fieldName);

        if (typeof value === 'undefined' || value === null) return errors;

        errors = validateValue(value, constraint, errors, className, fieldName);
      }

      // if there is a custom validator function, apply it
      if (typeof constraint.validator === 'function') {
        validatorResult = constraint.validator(value, instance);
        if (validatorResult !== true) {
          if (validatorResult && validatorResult instanceof FieldError) {
            errors.push(validatorResult);
          } else if (validatorResult && isArray(validatorResult) && validatorResult[0] instanceof FieldError) { //Warning! Assumes all members of the array are field errors
            for (var i = 0; i < validatorResult.length; i++) {
              errors.push(validatorResult[i]);
            }
          } else {
            if (validatorResult && typeof validatorResult === 'string') {
              // use the result as the code
            } else if (validatorResult && typeof validatorResult === 'object' && typeof validatorResult.code === 'string') {
              validatorResult = validatorResult.code;
            } else {
              validatorResult = className + '.' + fieldName + '.invalid.validator.message';
            }
            errors.push(new FieldError({
              rejectedValue: value,
              code: validatorResult,
              defaultCode: 'default.invalid.validator.message',
              field: fieldName,
              arguments: [fieldName, className, value]
            }));
          }
        }
      }
    }

    return errors;
  }

  //Validate only whether the value is the correct type.
  function validateType(value, constraint, errors, className, fieldName, instance) {
    errors = errors || [];
    var msgPrefix = isString(className) && isString(fieldName) ? className + '.' + fieldName : 'default';

    if (constraint.type === 'Domain' || constraint.type === 'DomainLink' && !constraint.simpleLink
      ? !isObject(value) || (value.id === null || value.collection === null)
      : typeof value === 'undefined' || value === null) {
      if (constraint.nullable) {
        return errors;
      } else {
        errors.push(new FieldError({
          rejectedValue: value,
          code: msgPrefix + '.null.message',
          defaultCode: 'default.null.message',
          field: fieldName,
          arguments: {property: fieldName, className: className, rejectedValue: value}
        }));
        return errors;
      }
    }

    var code = '';
    switch (constraint.type) {
      case 'boolean':
      case 'number':
        if (typeof value !== constraint.type) {
          code = 'typeMismatch.' + constraint.type;
        }
        break;
      case 'string':
      case 'email':
      case 'URL':
      case 'creditCard':
        if (typeof value !== 'string') {
          code = 'typeMismatch.' + constraint.type;
        }
        break;
      case 'Date':
        if (!isDate(value) && value !== $window.Firebase.ServerValue.TIMESTAMP) {
          code = 'typeMismatch.Date';
        }
        break;
      case 'JSON':
        if (!isObject(value) || isFunction(value)) {
          code = 'typeMismatch.JSON';
        }
        break;
      case 'GeoJSON':
        if (!isObject(value) || isFunction(value)) {
          code = 'typeMismatch.GeoJSON';
        }
        break;
      default:
        break;
    }

    if (code !== '') {
      errors.push(new FieldError({
        rejectedValue: value,
        code: code,
        defaultCode: code,
        field: fieldName,
        arguments: {property: fieldName, className: className, rejectedValue: value}
      }));
    }

    return errors;
  }

  function validateValue(value, constraint, errors, className, fieldName, instance) {
    errors = errors || [];
    var msgPrefix = isString(className) && isString(fieldName) ? className + '.' + fieldName : 'default';
    var regEx;

    // Non-type specific constraints
    if (constraint.hasOwnProperty('notEqual') && value === constraint.notEqual) {
      errors.push(new FieldError({
        rejectedValue: value,
        code: className + '.' + fieldName + '.not.equal.message',
        defaultCode: 'default.not.equal.message',
        field: fieldName,
        arguments: {property: fieldName, className: className, rejectedValue: value, comparedValue: constraint.notEqual}
      }));
    }

    if (constraint.hasOwnProperty('inList') && !includes(constraint.inList, value)) {
      errors.push(new FieldError({
        rejectedValue: value,
        code: className + '.' + fieldName + '.not.inlist.message',
        defaultCode: 'default.not.inlist.message',
        field: fieldName,
        arguments: {
          property: fieldName,
          className: className,
          rejectedValue: value,
          comparedValue: constraint.inList.toString()
        }
      }));
    }

    switch (constraint.type) {
      case 'boolean':
        return errors;
      case 'number':
        if (isNumber(value)) {
          if (isNumber(constraint.max) && value > constraint.max) {
            errors.push(new FieldError({
              rejectedValue: value,
              code: className + '.' + fieldName + '.invalid.max.message',
              defaultCode: 'default.invalid.max.message',
              field: fieldName,
              arguments: {
                property: fieldName,
                className: className,
                rejectedValue: value,
                comparedValue: constraint.max
              }
            }));
          } else if (isNumber(constraint.min) && value < constraint.min) {
            errors.push(new FieldError({
              rejectedValue: value,
              code: className + '.' + fieldName + '.invalid.min.message',
              defaultCode: 'default.invalid.min.message',
              field: fieldName,
              arguments: {
                property: fieldName,
                className: className,
                rejectedValue: value,
                comparedValue: constraint.min
              }
            }));
          } else if (constraint.size && (value < constraint.size[0] || value > constraint.size[1])) {
            errors.push(new FieldError({
              rejectedValue: value,
              code: className + '.' + fieldName + '.invalid.size.message',
              defaultCode: 'default.invalid.size.message',
              field: fieldName,
              arguments: {
                property: fieldName,
                className: className,
                rejectedValue: value,
                comparedMin: constraint.size[0],
                comparedMax: constraint.size[1]
              }
            }));
          } else if (constraint.range && (value < constraint.range[0] || value > constraint.range[1])) {
            errors.push(new FieldError({
              rejectedValue: value,
              code: className + '.' + fieldName + '.invalid.range.message',
              defaultCode: 'default.invalid.range.message',
              field: fieldName,
              arguments: {
                property: fieldName,
                className: className,
                rejectedValue: value,
                comparedMin: constraint.range[0],
                comparedMax: constraint.range[1]
              }
            }));
          }
        }
        break;
      case 'email':
        regEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (value && typeof value === 'string' && !regEx.test(value)) {
          errors.push(new FieldError({
            rejectedValue: value,
            code: className + '.' + fieldName + '.invalid.email.message',
            defaultCode: 'default.invalid.email.message',
            field: fieldName,
            arguments: {property: fieldName, className: className, rejectedValue: value}
          }));
        }
        /* fall-through */
      case 'string':
        if ((constraint.blank === false || (isUndefined(constraint.blank) && !constraint.nullable)) && value === '') {
          errors.push(new FieldError({
            rejectedValue: value,
            code: msgPrefix + '.blank.message',
            defaultCode: 'default.blank.message',
            field: fieldName,
            arguments: {property: fieldName, className: className, rejectedValue: value}
          }));
        } else if (typeof value === 'string' && constraint.size && (value.length < constraint.size[0] || value.length > constraint.size[1])) {
          errors.push(new FieldError({
            rejectedValue: value,
            code: msgPrefix + '.invalid.size.message',
            defaultCode: 'default.invalid.size.message',
            field: fieldName,
            arguments: {
              property: fieldName,
              className: className,
              rejectedValue: value,
              comparedMin: constraint.size[0],
              comparedMax: constraint.size[1]
            }
          }));
        }
        break;
      case 'Date':
        if (isDate(constraint.max) && isNumber(value) && value.getTime() > constraint.max.getTime()) {
          errors.push(new FieldError({
            rejectedValue: value,
            code: msgPrefix + '.invalid.max.message',
            defaultCode: 'default.invalid.max.message',
            field: fieldName,
            arguments: {property: fieldName, className: className, rejectedValue: value, comparedValue: constraint.max}
          }));
        } else if (isDate(constraint.min) && isNumber(value) && value.getTime() < constraint.min.getTime()) {
          errors.push(new FieldError({
            rejectedValue: value,
            code: msgPrefix + '.invalid.min.message',
            defaultCode: 'default.invalid.min.message',
            field: fieldName,
            arguments: {property: fieldName, className: className, rejectedValue: value, comparedValue: constraint.min}
          }));
        }
        break;
      case 'JSON':
        if (constraint.stringify) {
          try {
            JSON.stringify(value);
          } catch (error) {
            errors.push(new FieldError({
              rejectedValue: value,
              code: msgPrefix + '.json.malformed.message',
              defaultCode: 'default.json.malformed.message',
              field: fieldName,
              arguments: {property: fieldName, className: className, rejectedValue: value, comparedValue: constraint.min}
            }));
          }
        }

        if (value && !constraint.blank && isObject(value) && equals(value, {})) {
          errors.push(new FieldError({
            rejectedValue: value,
            code: msgPrefix + '.blank.message',
            defaultCode: 'default.blank.message',
            field: fieldName,
            arguments: {property: fieldName, className: className, rejectedValue: value}
          }));
        }
        break;
      case 'GeoJSON':
        try {
          JSON.stringify(value);
        } catch (error) {
          errors.push(new FieldError({
            rejectedValue: value,
            code: msgPrefix + '.json.malformed.message',
            defaultCode: 'default.json.malformed.message',
            field: fieldName,
            arguments: {property: fieldName, className: className, rejectedValue: value, comparedValue: constraint.min}
          }));
        }
        // TODO: consider using https://github.com/craveprogramminginc/GeoJSON-Validation to validate adherence to spec
        break;
      case 'Domain':
        // TODO: implement
        break;
      case 'DomainLink':
        // TODO: implement
        break;
      case 'URL':
        // TODO: add URL verification.
        break;
      default:
        break;
    }

    return errors;
  }
}


// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/DomainValidationService.js